import "./BrandProfile.scss";
import { Container, Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import Auth from "@aws-amplify/auth";
import { useNavigate, useParams } from "react-router-dom";
import { GetUserProfile } from "../../../API/endpoints/User";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/header/NavBar";
import BreadCrumb from "../../components/header/BreadCrumb";
import {
  GetBrand,
  GetBrandPreferences,
  GetBrandProducts,
} from "../../../API/endpoints/Brands";
import {
  GetPermissionsByRoleAndModuleID,
  GetRoleById,
} from "../../../API/endpoints/RolesAndPermissions/Roles";
import { Avatar } from "@mui/material";
import LinkedInIcon from "../../components/BrandsPartnerComponents/LinkedInIcon";
import FacebookIcon from "../../components/BrandsPartnerComponents/FacebookIcon";
import InstagramIcon from "../../components/BrandsPartnerComponents/InstagramIcon";
import MarketPreference from "../components/MarketPreference";
import ProductList from "../../components/Brand/ProductList";
// import { GetDocumentSettings } from "../../../API/endpoints/document";

const Brand = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [userID, setUserID] = useState<string | undefined>("");
  const [userProfile, setUserProfile] = useState<any>({});
  const [roleID, setRoleID] = useState<number>(0);
  const [permissions, setPermissions] = useState<any[]>([]);
  const [brandName, setBrandName] = useState<string | undefined>("");
  const [data, setData] = useState<any>();
  const [marketPreference, setMarketPreference] = useState<any>();
  const [engagementModels, setEngagementModels] = useState<any>([]);
  // const [docTotal, setDocTotal] = useState(0)
  const [activeTab, setActiveTab] = useState("market-preferences");
  const [productData, setProductData] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [dataCount, setDataCount] = useState(0);
  const [searchParam, setSearchParam] = useState<string>("");
  const [refresh, setRefresh] = useState(false);

  const tabClasses = (tab: string) =>
    `inline-block px-3 pt-2 pb-[10px] border-b-2 cursor-pointer font13-medium transition-colors duration-200 ${
      activeTab === tab
        ? "gray-800 border-[#12B76A]"
        : "gray-600 border-transparent hover:text-gray-600 hover:border-gray-300"
    }`;

  useEffect(() => {
    setUserID(Cookies.get("userID"));
  }, []);

  function stringToColor(string: string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }

  function stringAvatar(name: string) {
    const splitName = name.split(" ");
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${splitName[0][0]}${splitName[1] ? splitName[1][0] : ""}`,
    };
  }

  const iconList = {
    facebook: <FacebookIcon />,
    linkedin: <LinkedInIcon />,
    instagram: <InstagramIcon />,
  };

  const getSubCategories = (name: string) => {
    const category = data?.brand_categories.find(
      (item: any) => item.focus_category === name
    );
    if (category && category?.sub_categories?.length > 0) {
      return `${category?.sub_categories[0]}${
        category?.sub_categories?.[1] ? ", " + category?.sub_categories[1] : ""
      }`;
    } else {
      return "-";
    }
  };

  console.log("Brand Data: ", data?.brand_categories);
  useEffect(() => {
    if (userID) {
      (async () => {
        const response = await GetUserProfile(userID);
        if (response?.data) {
          setRoleID(response.data?.user_roles[0]?.roles.id);
          setUserProfile(response?.data);
        }
      })();
    }
  }, [userID, navigate]);

  useEffect(() => {
    (async () => {
      const roleDetails = await GetRoleById(roleID?.toString());

      if (roleDetails?.data?.type === "organization") {
        const response = await GetPermissionsByRoleAndModuleID(
          roleID.toString(),
          "8"
        );
        setPermissions(response?.data);
      } else if (roleDetails?.data?.type === "administrative") {
        const response = await GetPermissionsByRoleAndModuleID(
          roleID.toString(),
          "2"
        );
        setPermissions(response?.data);
      }
    })();
  }, [roleID]);

  useEffect(() => {
    const GetBrandData = async () => {
      const response = await GetBrand(params.id);
      if (response?.data) {
        setBrandName(response.data.brand_name);
        setData(response.data);
      }
    };
    const GetPreference = async () => {
      const response = await GetBrandPreferences(params.id || "");
      if (response?.data?.market_preference) {
        setMarketPreference(response.data.market_preference);
      }
      if (response?.data?.brand_preference?.engagement_model.length !== 0) {
        setEngagementModels(response.data.brand_preference.engagement_model);
      }
    };
    // const GetDocumentsCount = async () => {
    //     const response = await GetDocumentSettings("1", "")
    //     if (response?.data?.count) {
    //         setDocTotal(response.data.count)
    //     }
    // }
    GetBrandData();
    GetPreference();
    // GetDocumentsCount();
  }, [params.id]);

  useEffect(() => {
    if (params?.id) {
      const GetBrandProductsData = async () => {
        const response = await GetBrandProducts(
          params.id,
          page + 1,
          searchParam
        );
        if (response?.data) {
          setDataCount(response.data.count);
          setProductData(response.data.rows);
        }
      };

      GetBrandProductsData();
    }
  }, [params.id, page, searchParam, refresh]);

  const normalizeUrl = (url: string) => {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      return "https://" + url;
    }
    return url;
  };

  const breadcrumbData = [
    {
      name: "Brand Management",
      url: "/BrandManagement",
      active: false,
    },
    {
      name: "Brands",
      url: "/BrandManagement",
      active: false,
    },
    {
      name: brandName || "",
      url: `/brand/${params.id}`,
      active: true,
    },
  ];
  return (
    <Container fluid className="pge-layout">
      <Row>
        <Col className="sidebar">
          <Sidebar active="brand" />
        </Col>
        <Col className="content-section">
          <Navbar userProfile={userProfile} />
          <BreadCrumb breadcrumbData={breadcrumbData} />
          <Container fluid className="profile-container">
            <Row className="row-1">
              <Col xs={12} className="col-1">
                <Row className="profile-box">
                  <Col xs={3} className="col-profile">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "13px",
                      }}
                    >
                      <Avatar
                        style={{
                          marginRight: "12px",
                          backgroundColor: "#EFF8FF",
                          color: "#0152FB",
                          fontSize: "14px",
                          fontWeight: 500,
                          alignItems: "center",
                        }}
                        {...stringAvatar(data?.brand_name || "")}
                      />
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <h6 className="brand_name !h-[100%]">
                          {data?.brand_name}
                        </h6>
                        <div className="brand-finance">
                          <div>{data?.years_of_operation}</div>•
                          <div>${data?.current_revenue}</div>
                        </div>
                      </div>
                    </div>
                    <div className="social-media">
                      <div className="font12-regular gray-600 social-media-heading">
                        Social Media:{" "}
                      </div>
                      {data?.social_media.map(
                        (item: {
                          _id: string;
                          platform: "facebook" | "instagram" | "linkedin";
                          url: string;
                        }) => (
                          <div>
                            <a
                              href={normalizeUrl(item?.url)}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {iconList[item.platform]}
                            </a>
                          </div>
                        )
                      )}
                    </div>
                    <div
                      className="mt24px"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                      }}
                    >
                      <div className="font12-regular gray-600">
                        Marketplaces
                      </div>
                      <div className="market-place-item-container">
                        {data?.market_place.map(
                          (item: { platform: string; url: string }) => (
                            <div className="market-place-item">
                              <div className="market-place-item-text">
                                <a
                                  href={normalizeUrl(item?.url)}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {item.platform}
                                </a>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </Col>
                  <Col xs={4} className="col-digital flex flex-col gap-[20px]">
                    <Row className="col-digital-container !mb-[0]">
                      <div className="col-digital-item">
                        <Col style={{ gap: "4px" }}>
                          <div className="font12-regular gray-600 col-digital-item-heading !h-[100%]">
                            Engagement Model
                          </div>
                          <div className="col-digital-item-text !h-[100%]">
                            {data?.brand_preference?.engagement_model?.[0]}
                          </div>
                        </Col>
                      </div>
                      <div className="col-digital-item">
                        <Col style={{ gap: "4px" }}>
                          <div className="font12-regular gray-600 col-digital-item-heading !h-[100%]">
                            Exclusivity Tenure
                          </div>
                          <div className="col-digital-item-text !h-[100%]">
                            {data?.brand_preference?.exclusivity_tenure}
                          </div>
                        </Col>
                      </div>
                    </Row>
                    <Row className="col-digital-container !mb-[0]">
                      <div className="col-digital-item">
                        <Col style={{ gap: "4px" }}>
                          <div className="font12-regular gray-600 col-digital-item-heading !h-[100%]">
                            FOB/CIF Preference
                          </div>
                          <div className="col-digital-item-text !h-[100%]">
                            {data?.brand_preference?.fob_preference?.[0]}
                          </div>
                        </Col>
                      </div>
                      <div className="col-digital-item">
                        <Col style={{ gap: "4px" }}>
                          <div className="font12-regular gray-600 col-digital-item-heading !h-[100%]">
                            Marketing Investment
                          </div>
                          <div className="col-digital-item-text !h-[100%]">
                            {data?.brand_preference?.marketing_investments}
                          </div>
                        </Col>
                      </div>
                    </Row>
                  </Col>
                  <Col
                    xs={5}
                    className="col-basicinfo flex flex-col gap-[20px]"
                  >
                    <Row className="col-digital-container !mb-[0]">
                      <div className="col-digital-item">
                        <Col style={{ gap: "4px" }}>
                          <div className="font12-regular gray-600 col-digital-item-heading !h-[100%]">
                            Health Supplements
                          </div>
                          <div className="col-digital-item-text !h-[100%]">
                            {getSubCategories("Health Supplements")}&nbsp;
                            {data?.brand_categories.find(
                              (item: any) =>
                                item.focus_category === "Health Supplements"
                            )?.sub_categories?.length > 2 ? (
                              <span className="font12-regular more-items">
                                -{" "}
                                {data?.brand_categories.find(
                                  (item: any) =>
                                    item.focus_category === "Health Supplements"
                                )?.sub_categories?.length - 2}{" "}
                                more items
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                      </div>
                      <div className="col-digital-item">
                        <Col style={{ gap: "4px" }}>
                          <div className="font12-regular gray-600 col-digital-item-heading !h-[100%]">
                            Beauty & Skin
                          </div>
                          <div className="col-digital-item-text !h-[100%]">
                            {getSubCategories("Beauty & Skin")}&nbsp;
                            {data?.brand_categories.find(
                              (item: any) =>
                                item.focus_category === "Beauty & Skin"
                            )?.sub_categories?.length > 2 ? (
                              <span className="font12-regular more-items">
                                -{" "}
                                {data?.brand_categories.find(
                                  (item: any) =>
                                    item.focus_category === "Beauty & Skin"
                                )?.sub_categories?.length - 2}{" "}
                                more items
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                      </div>
                    </Row>
                    <Row className="col-digital-container !mb-[0]">
                      <div className="col-digital-item">
                        <Col style={{ gap: "4px" }}>
                          <div className="font12-regular gray-600 col-digital-item-heading !h-[100%]">
                            Functional Food & Beverages
                          </div>
                          <div className="col-digital-item-text !h-[100%]">
                            {getSubCategories("Functional Food & Beverages")}
                            &nbsp;
                            {data?.brand_categories.find(
                              (item: any) =>
                                item.focus_category ===
                                "Functional Food & Beverages"
                            )?.sub_categories?.length > 2 ? (
                              <span className="font12-regular more-items">
                                -{" "}
                                {data?.brand_categories.find(
                                  (item: any) =>
                                    item.focus_category ===
                                    "Functional Food & Beverages"
                                )?.sub_categories?.length - 2}{" "}
                                more items
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                      </div>
                      <div className="col-digital-item">
                        <Col style={{ gap: "4px" }}>
                          <div className="font12-regular gray-600 col-digital-item-heading !h-[100%]">
                            Pet Nutrition
                          </div>
                          <div className="col-digital-item-text !h-[100%]">
                            {getSubCategories("Pet Nutrition")}&nbsp;
                            {data?.brand_categories.find(
                              (item: any) =>
                                item.focus_category === "Pet Nutrition"
                            )?.sub_categories?.length > 2 ? (
                              <span className="font12-regular more-items">
                                -{" "}
                                {data?.brand_categories.find(
                                  (item: any) =>
                                    item.focus_category === "Pet Nutrition"
                                )?.sub_categories?.length - 2}{" "}
                                more items
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                      </div>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col className="col-market-prefer" xs={12}>
                <div className="mb-4 border-b border-gray-200">
                  <ul
                    className="flex flex-wrap -mb-px text-sm font-medium text-center gap-x-[10px]"
                    role="tablist"
                  >
                    <li role="presentation">
                      <button
                        onClick={() => setActiveTab("market-preferences")}
                        className={tabClasses("market-preferences")}
                      >
                        Market Preferences
                      </button>
                    </li>
                    <li role="presentation">
                      <button
                        onClick={() => setActiveTab("products")}
                        className={tabClasses("products")}
                      >
                        Products
                      </button>
                    </li>
                  </ul>
                </div>

                <div>
                  {activeTab === "market-preferences" && (
                    <MarketPreference marketPreference={marketPreference} />
                  )}
                  {activeTab === "products" && (
                    <ProductList
                      rows={productData}
                      page={page}
                      setPage={setPage}
                      dataCount={dataCount}
                      setSearchParam={setSearchParam}
                      refresh={refresh}
                      setRefresh={setRefresh}
                      brandList={[
                        {
                          name: brandName || "",
                          value: params.id || "",
                          categories: data?.brand_categories,
                        },
                      ]}
                      selectedBrand={params.id}
                      userType={userProfile?.user_type}
                    />
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
    </Container>
  );
};

export default Brand;
